require('./bootstrap');

require('./extensions/jQuery');
require('./extensions/Function');
require('./extensions/Event');
require('./extensions/Array');
require('./extensions/String');
require('./extensions/Swal');

require('./app/FormStorage');
require('./app/AjaxRequest');

require('./theme/presentation');

require('./components/card');
require('./components/tooltip');
require('./components/SplitPane');
require('./components/Section');
require('./components/image-editing');
require('./components/ImageUpload');
require('./components/ImageMarker');
require('./components/ImageMarkerPoint');
require('./components/PhotoCapture');

require('./modules/modules.js');
